import { render, staticRenderFns } from "./PSDPreview.vue?vue&type=template&id=7ce9c454&scoped=true"
import script from "./PSDPreview.vue?vue&type=script&lang=js"
export * from "./PSDPreview.vue?vue&type=script&lang=js"
import style0 from "./PSDPreview.vue?vue&type=style&index=0&id=7ce9c454&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce9c454",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ce9c454')) {
      api.createRecord('7ce9c454', component.options)
    } else {
      api.reload('7ce9c454', component.options)
    }
    module.hot.accept("./PSDPreview.vue?vue&type=template&id=7ce9c454&scoped=true", function () {
      api.rerender('7ce9c454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/psd-layers/PSDPreview.vue"
export default component.exports